import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { OrganisationHeader } from "../common/OrganisationHeader";
import { Application } from "./sections/Application";
import { Skeleton } from "@material-ui/lab";
import { OrganisationAppBar } from "../OrganisationAppBar";
import { Helmet } from "react-helmet";
import { OrgScrollableAreaTabs } from "../ActivityFeed/OrgScrollableAreaTabs";
import { useOrganisationState } from "../../hooks/useOrganisationState";
import { NavigatingTabs } from "../common/NavigatingTabs";
import { useApplicationState } from "../../hooks/useApplicationState";
import { Review } from "./sections/Review";
import { Scopes } from "./sections/Scopes";
import { Organisation } from "./sections/Organisation";
import { UserType } from "../../redux/types";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserRole } from "../../domain/userRole";
import { authSelector } from "../../redux/selectors";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      marginTop: theme.contentOffsets.AFTER_RECORD_HEADER,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "25px", // theme.contentOffsets.AFTER_MAIN_APPBAR
    },
  },
}));

export const ApplicationView: React.FC = () => {
  const classes = useStyles();

  const { itemId, applicationId } = useParams<{
    itemId: string;
    applicationId: string;
  }>();

  const { userType, isInRole } = useAuth(authSelector);

  const canEdit = isInRole(UserRole.ITAdmin, UserRole.OfqualRecognitionAdmin);

  const orgState = useOrganisationState(itemId);
  const applicationState = useApplicationState(orgState?.org.id, applicationId);

  // we've may have come from low-down on the parent organisation page
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div className={classes.root}>
      <Helmet>
        <title>The Portal - Organisations - Application</title>
      </Helmet>
      <OrganisationAppBar />

      <OrganisationHeader organisationState={orgState} />

      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
          {orgState && applicationState ? (
            <>
              <NavigatingTabs
                dataTest="orgs-main-tabs"
                tabs={[
                  {
                    id: "",
                    label: "Application",
                    content: (
                      <Application
                        orgState={orgState}
                        applicationState={applicationState}
                        canEdit={canEdit}
                      />
                    ),
                  },
                  {
                    id: "review",
                    label: "Review",
                    content: (
                      <Review
                        orgState={orgState}
                        applicationState={applicationState}
                        canEdit={canEdit}
                      />
                    ),
                  },
                  {
                    id: "scopes",
                    label: "Scopes",
                    content: (
                      <Scopes
                        orgState={orgState}
                        applicationState={applicationState}
                        canEdit={canEdit}
                      />
                    ),
                  },
                  {
                    id: "details",
                    label: "Organisations Details",
                    content: (
                      <Organisation
                        orgState={orgState}
                        applicationState={applicationState}
                        canEdit={canEdit}
                      />
                    ),
                  },
                ]}
              />
            </>
          ) : (
            <>
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <br />
              <Skeleton variant="rect" height={118} />
            </>
          )}
        </Grid>

        <Grid item lg={4} xs={12}>
          <OrgScrollableAreaTabs
            orgState={orgState}
            isOfqualUser={userType === UserType.Ofqual}
          />
        </Grid>
      </Grid>
    </div>
  );
};
